import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth, formatApiError } from "./AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) {
    if (user.must_change_password) {
      return <Navigate to="/admin/change-password" replace />;
    }
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      navigate(u?.must_change_password ? "/admin/change-password" : "/admin", {
        replace: true,
      });
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#0A0F1F",
        color: "#fff",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        style={{
          width: 360,
          padding: 28,
          background: "#101C35",
          border: "1px solid #14213D",
          borderRadius: 4,
        }}
      >
        <h1 style={{ margin: "0 0 18px 0", fontSize: 22, letterSpacing: 1 }}>
          The Next Stage — Back Office
        </h1>
        <label style={{ display: "block", fontSize: 12, opacity: 0.8 }}>Email</label>
        <input
          data-testid="admin-login-email"
          autoComplete="username"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <label style={{ display: "block", fontSize: 12, opacity: 0.8, marginTop: 12 }}>
          Password
        </label>
        <input
          data-testid="admin-login-password"
          autoComplete="current-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        {err && (
          <div data-testid="admin-login-error" style={{ color: "#ff6b6b", marginTop: 10, fontSize: 13 }}>
            {err}
          </div>
        )}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          style={{
            marginTop: 18,
            width: "100%",
            padding: "10px 14px",
            background: "#E5B25D",
            color: "#0A0F1F",
            border: 0,
            fontWeight: 700,
            cursor: busy ? "wait" : "pointer",
          }}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  background: "#0A0F1F",
  border: "1px solid #2a3556",
  color: "#fff",
  borderRadius: 2,
  marginTop: 4,
  fontSize: 14,
  boxSizing: "border-box",
};
